import settingReducer from "./settingReducer";

const settingReducers = {
    setting: settingReducer
}

export default settingReducers;